import { Button } from "@workspace/web-ui/components/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@workspace/web-ui/components/form";

import { Condition } from "../../types";
import { useCondition } from "../../hooks/use-condition";
import { Input } from "@workspace/web-ui/components/input";
import { Checkbox } from "@workspace/web-ui/components/checkbox";

interface ConditionFormProps {
  condition?: Condition;
  onClose?: () => void;
}

export const ConditionForm = ({ condition, onClose }: ConditionFormProps) => {
  const { form, onSubmit, isLoading } = useCondition({ condition, onClose });

  const watchIsReceivingTreatment = form.watch("is_treated")

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="space-y-4"
        aria-label={condition ? "Update Allergy Form" : "Add Allergy Form"}
      >
        <FormField
          control={form.control}
          name="name"
          render={({ field }) => (
            <FormItem>
              <FormLabel htmlFor="name">Condition name</FormLabel>
              <FormControl>
                <Input
                  id="name"
                  className="w-full"
                  placeholder="Enter your condition"
                  aria-label="Name"
                  aria-required="true"
                  {...field}
                />
              </FormControl>
              <FormMessage role="alert" />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="date_diagnosed"
          render={({ field }) => (
            <FormItem>
              <FormLabel htmlFor="diagnosisDate">When were you diagnosed?</FormLabel>
              <FormControl>
                <Input
                  id="diagnosisDate"
                  className="w-full"
                  placeholder="Enter your condition"
                  aria-label="Name"
                  aria-required="true"
                  {...field}
                  type="date"
                />
              </FormControl>
              <FormMessage role="alert" />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="is_treated"
          render={({ field }) => (
            <FormItem className="flex items-center gap-2">
              <FormControl className="mt-2">
                <Checkbox
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
              <FormLabel className="">
                Currently receiving treatment
              </FormLabel>
            </FormItem>
          )}
        />

        {watchIsReceivingTreatment && (
          <FormField
            control={form.control}
            name="medication"
            render={({ field }) => (
              <FormItem>
                <FormLabel htmlFor="medication">Current Treatment</FormLabel>
                <FormControl>
                  <Input
                    id="medication"
                    className="w-full"
                    placeholder="What medication are taking?"
                    aria-label="medication"
                    aria-required="true"
                    {...field}
                  />
                </FormControl>
                <FormMessage role="alert" />
              </FormItem>
            )}
          />
        )}

        <div className="flex items-center w-full justify-end gap-2">
          <Button
            className="transition-colors bg-[#4272DD] w-full rounded-[8px] duration-200 "
            type="submit"
            disabled={isLoading}
            aria-busy={isLoading}
          >
            {isLoading ? condition ? "Updating..." : "Saving..." : "Save"}
          </Button>
        </div>
      </form>
    </Form>
  );
};
